import { Toaster as Sonner } from 'sonner';

import { useTheme } from '@/theme/theme';

/*
 * Restyled to ScreenAtlas tokens (web/docs/ui-ux.md §5): transient feedback,
 * bottom-centre, auto-dismiss after 4s. Reads OUR theme context — no
 * next-themes.
 */

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
  const { preference } = useTheme();

  return (
    <Sonner
      theme={preference}
      position="bottom-center"
      duration={4000}
      gap={12}
      offset={80}
      // ≤ 600px Sonner ignores `offset` (16px default) — lift toasts above
      // the bottom tab bar and the home indicator instead of covering them.
      mobileOffset={{ bottom: 'calc(5rem + env(safe-area-inset-bottom, 0px))' }}
      toastOptions={{
        classNames: {
          toast:
            'group toast group-[.toaster]:rounded group-[.toaster]:bg-surface group-[.toaster]:text-body group-[.toaster]:text-ink group-[.toaster]:shadow-sm',
          description: 'group-[.toast]:text-caption group-[.toast]:text-ink-secondary',
          actionButton:
            'group-[.toast]:rounded-sm group-[.toast]:bg-accent group-[.toast]:px-3 group-[.toast]:py-1.5 group-[.toast]:text-subhead group-[.toast]:font-medium group-[.toast]:text-on-accent',
          cancelButton:
            'group-[.toast]:rounded-sm group-[.toast]:bg-surface-alt group-[.toast]:px-3 group-[.toast]:py-1.5 group-[.toast]:text-subhead group-[.toast]:font-medium group-[.toast]:text-ink',
        },
      }}
      {...props}
    />
  );
};

export { Toaster };
